import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './App.css';
import Alert from './routes/Dashboard/Alerts';
import CompanyMonitoring from './routes/Dashboard/CompanyMonitoring';
import DashboardLayout from './routes/Dashboard/DashboardLayout';
import Leads from './routes/Dashboard/Leads';
import Home from './routes/Home';
import Login from './routes/Login';
import Signup from './routes/Signup';
import Settings from './routes/Dashboard/Settings';
import SuperLogin from './routes/Dashboard/Superlogin';
import AiCsv from './routes/AI-Csv';

function App() {
    return (
        <>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/superlogin" element={<SuperLogin />} />
                <Route path="/Aicsv" element={<AiCsv />} />
                <Route path="/dashboard" element={<DashboardLayout />}>
                    <Route index element={<Alert />} />
                    <Route path="/dashboard/leads" element={<Leads />} />
                    <Route path="/dashboard/companies" element={<CompanyMonitoring />} />
                    <Route path="/dashboard/settings" element={<Settings />} />
                </Route>
            </Routes>
            <ToastContainer />
        </>
    );
}

export default App;
